import React, { useState } from 'react'
import {NavLink} from 'react-router-dom';
import '../../assets/css/header.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
export default function MenuHeader() {

    const [show, setShow] = useState(true)
    const [show1, setShow1] = useState(true)
    const [serviceClass,setServiceClass]=useState('');
    const handleClick=()=>{
        setServiceClass('');
    }

        return (
          
            <nav className="navbar navbar-expand-lg">
                <span className={ show ? 'navbar-toggler'  : 'navbar-toggler border' }
                onClick={ ()=>setShow(!show)} >
                    <span className="bar1"></span>
                    <span className="bar2"></span>
                    <span className="bar3"></span>
                </span>
                <div className={ show ? 'collapse navbar-collapse' : 'collapse navbar-collapse active'}>
                    <ul className="navbar-nav ms-auto nav-header reset">
                        <li className="nav-item">
                            <NavLink to= '/'   onClick={ ()=>setShow(!show)} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Home</NavLink>
                        </li>
                        <li className="nav-item has-dropdown " onMouseEnter={()=>{setServiceClass('service-class')}} onMouseLeave={()=>{
                            setServiceClass('')
                            }}>
                            <h4 className="single-nav-links nav-link">Offerings</h4>
                            <span className='drp-arrow' onClick={ ()=>setShow1(!show1)}><FontAwesomeIcon icon={faAngleDown} className='sub-menu-click' /></span>
                            <div className={`mega-menu ${serviceClass} ${show1 ? "" : "sub-menu-slider" }`} >
                                <div className='inner-menus-col'>
                                   
                                    <div className='sub-menu-col'>
                                        <h4>Products</h4>
                                        <div className='wrap-inner-menu'>
                                            <ul className='sub-menus'>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/products/procurement-management-software'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Prime: Procurement</NavLink>
                                                </li>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/products/invoice-generation-software'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Prime: Cash Flow Management</NavLink>
                                                </li>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/products/exployee-expenses-management-system'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Prime: Employee Benefits</NavLink>
                                                </li>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/products/employee-management-system'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Choice Touch</NavLink>
                                                </li>
                                               
                                            </ul>
                                            <ul className='sub-menus'>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/products/customer-engagement-platform'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Greetly</NavLink>
                                                </li>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/products/insurance-management-system'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Drive Assure</NavLink>
                                                </li>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/products/transport-management-system'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Trans-Track</NavLink>
                                                </li>
                                                {/* <li className='nav-item-sub'>
                                                    <NavLink to= '/products/telelyzer'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Telelyzer</NavLink>
                                                </li> */}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className='sub-menu-col'>
                                        <h4>Services</h4>
                                        <div className='wrap-inner-menu'>
                                            <ul className='sub-menus'>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/services/android-app-development'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Android Development</NavLink>
                                                </li>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/services/ios-app-development'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>iOS Development</NavLink>
                                                </li>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/services/web-development-services'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Web Development</NavLink>
                                                </li>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/services/tech-consulting-services' onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Tech Consultation</NavLink>
                                                </li>
                                            </ul>
                                            <ul className='sub-menus'>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/services/data-loss-protection'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Data Loss Prevention (DLP)</NavLink>
                                                </li>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/services/data-classification-platform'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Data Classification Platform</NavLink>
                                                </li>
                                                <li className='nav-item-sub'>
                                                    <NavLink to= '/services/red-teaming-services'   onClick={ ()=>{setShow(!show)
                                                    handleClick()}} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Red Teaming</NavLink>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </li>
                        
                        
                       
                        <li className="nav-item">
                            <NavLink to= '/case-studies'   onClick={ ()=>setShow(!show)} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Case Studies</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to= '/about-us'   onClick={ ()=>setShow(!show)} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>About Us</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to= '/contact-us'   onClick={ ()=>setShow(!show)} className={({isActive}) => "single-nav-links nav-link " + (isActive ? "active-header" :'')}>Contact Us</NavLink>
                        </li>
                       
                    </ul>
                </div>
            </nav>
          
        )
    }

